$(function () {
  $('a[href^="#"]').click(function () {
    let speed = 500
    let href = $(this).attr("href")
    let target = $(href == "#" || href == "" ? 'html' : href)
    let position = target.offset().top - 130
    $("html, body").animate({ scrollTop: position }, speed, "swing")
    return false
  })

  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    $('.effect-fade').each(function () {
      var elemPos = $(this).offset().top
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-scroll')
      }
    })
  })

  new Splide('.js-top-splide', {
    type: 'loop',
    drag: false,
    arrows: false,
    pagination: false,
    autoWidth: true,
    gap: '10px',
    autoScroll: { speed: 2, pauseOnHover: false }
  }).mount(window.splide.Extensions)

  const pickUpSplide = new Splide('.js-pick-up-splide', {
    type: 'loop',
    drag: true,
    pagination: false,
    perPage: 5,
    perMove: 1,
    focus: 'center',
    gap: '15px',
    arrows: true,
  })

  pickUpSplide.on('mounted', () => {
    setActive(pickUpSplide.index)
  })

  pickUpSplide.on('move', (newIndex) => {
    setActive(newIndex)
  })

  function setActive(activeIndex) {
    const Slides = pickUpSplide.Components.Slides.get()

    Slides.forEach(slideObj => {
      slideObj.slide.classList.remove('is-custom-active')
    })

    const active = pickUpSplide.Components.Slides.getAt(activeIndex)
    if (active) {
      active.slide.classList.add('is-custom-active')
    }
  }

  const pickUpWatches = new Splide('.js-pick-up-watches-splide', {
    type: 'loop',
    drag: true,
    autoWidth: true,
    pagination: false,
    perPage: 2,
    perMove: 1,
    focus: 'center',
    arrows: false,
    updateOnMove: true,
  })

  /**
  * pickupで時計の数が奇数か判定する関数
  */
  const watchesSplide = document.querySelector('.js-pick-up-watches-splide')
  const checkOddWatches = () => {
    // 現在のインデックスからスライド要素を取得
    const activeSlide = pickUpWatches.Components.Slides.getAt(pickUpWatches.index).slide

    if (!activeSlide) return

    const watches = activeSlide.querySelectorAll('.pick-up__watches-item a')
    const isOdd = watches.length % 2 !== 0

    if (isOdd) {
      watchesSplide.classList.add('is-odd')

    } else {
      watchesSplide.classList.remove('is-odd')
    }
  }

  // マウント完了時（読み込み時）およびスライド時に実行
  pickUpWatches.on('mounted move', () => {
    checkOddWatches()
  })

  //  picuUpSplideとpickUpWatchesを同期させる
  pickUpSplide.sync(pickUpWatches)

  pickUpSplide.mount()
  pickUpWatches.mount()

  new Splide('.js-style-splide', {
    type: 'loop',
    drag: true,
    arrows: false,
    pagination: true,
    perPage: 2,
    perMove: 1,
    focus: 'center',
    gap: '12px',
  }).mount()
})